
import {
    SET,
    REINIT
} from './types';

import {
    Actions,
} from './actions';

import {
    ProviderModal
} from './providermodal';

export const providerathenastate = (
    context: any,
    initial?:ProviderModal[],
) => {
    const initValue = initial || [];

    return (
        state: ProviderModal[] = initValue,
        action:Actions,
    ) => {
        const {
            type,
            payload,
        } = action;
        let updated = state;
        switch (type) {
            case SET:
                updated = payload
                break;

            case REINIT:
                updated = initValue;
                break;
        }
        return updated;
    }
};

